module.exports = __webpack_public_path__ + "31cedfb4b2f84a59c0ea569b373f1bbe.jpg";